import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../../theme';

const Form = styled.form`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: ${em(appTheme.sizing.formMaxWidth)};
  padding: 0;
`;

export default Form;



// WEBPACK FOOTER //
// ./src/modules/common/form/Form.js